import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-top: 20px;
  padding-bottom: 20px;
`;

export const NavigationButton = styled.div`
  display: flex;
  font-family: ${({ theme }) => theme.fonts.montserrat};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
  justify-content: center;
  align-items: flex-start;
  margin-top: 20px;
  svg {
    font-size: 28px;
  }
`;

export const PostDetails = styled.div<{ direction: 'left' | 'right' }>`
  display: flex;
  flex-direction: column;
  margin-right: ${({ direction }) => (direction === 'right' ? '20px' : 0)};
  margin-left: ${({ direction }) => (direction === 'left' ? '20px' : 0)};
  text-align: ${({ direction }) => (direction === 'left' ? 'left' : 'right')};
  ${({ theme }) => theme.BreakpointSmallMobile`
    max-width: 120px;
  `};
`;

export const BoldText = styled.div`
  font-family: ${({ theme }) => theme.fonts.montserrat};
  font-weight: 700;
  white-space: nowrap;
`;

export const NoramlText = styled.div`
  font-family: ${({ theme }) => theme.fonts.montserrat};
  color: ${({ theme }) => theme.colors.grey.hitGrey};
`;
